<template>
  <main-layout>
    <v-container>
      <h2>{{ $t('link_management') }}</h2>
      <p v-if="liffId" class="mt-3"><span class="primary--text">LIFF ID:</span> xxx</p>
      <DateFilter v-model="selectedDate" class="mt-3" />
      <v-toolbar flat color="transparent" class="toolbar mt-3">
        <v-spacer />
        <v-btn @click="handleLiffIdAdd">
          <v-icon>edit</v-icon>
          {{ $t('update_liff_id') }}
        </v-btn>
        <v-btn color="primary" @click="handleAdd">
          <v-icon>add</v-icon>
          {{ $t('Add') }}
        </v-btn>
      </v-toolbar>
      <v-layout wrap :style="{ margin: '-8px' }">
        <v-flex xs12 sm6 class="pa-2">
          <v-text-field
            v-model="query"
            prepend-inner-icon="search"
            :placeholder="$t('Search')"
            hide-details
            outline
            single-line
            @input="debounceSearch()"
          />
        </v-flex>
        <v-flex xs12 sm6 class="pa-2">
          <v-combobox
            v-model="events"
            :items="[]"
            placeholder="Event"
            multiple
            chips
            hide-details
            outline
            single-line
          />
        </v-flex>
      </v-layout>
      <v-layout wrap justify-end class="mt-3" :style="{ margin: '-4px' }">
        <v-flex shrink class="pa-1">
          <v-btn outline color="grey" class="ma-0" @click="exportData()">
            <v-icon>ios_share</v-icon>
            {{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <DataTable
        :items="items"
        :total="total"
        :pagination.sync="pagination"
        :loading="loading"
        class="mt-3"
        @edit="handleItemEdit"
        @delete="handleItemDelete"
      />
    </v-container>
    <FormDialog
      v-if="editedItem !== undefined"
      v-model="editedItem"
      @submit="handleFormSubmit"
      @close="editedItem = undefined"
    />
    <LiffIdFormDialog
      v-if="editedLiffId !== undefined"
      v-model="editedLiffId"
      @submit="handleLiffIdFormSubmit"
      @close="editedLiffId = undefined"
    />
  </main-layout>
</template>

<script>
import dayjs from 'dayjs'
import debounce from 'lodash/debounce'
import XLSX from 'xlsx'
import DateFilter from '@/components/view/dashboard/DateFilter'
import { DATETIME } from '@/constants/datetime'
import DataTable from './DataTable'
import FormDialog from './FormDialog'
import LiffIdFormDialog from './LiffIdFormDialog'

export default {
  components: {
    DateFilter,
    DataTable,
    FormDialog,
    LiffIdFormDialog
  },
  data() {
    return {
      selectedDate: {
        start: dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
        end: dayjs().format('YYYY-MM-DD')
      },
      query: '',
      events: [],
      items: [
        { name: 'test', url: 'https://www.google.com', createdAt: '2024-10-15T12:00:00+07:00' }
      ],
      total: 1,
      pagination: {
        rowsPerPage: 10
      },
      loading: false,
      editedItem: undefined,
      editedLiffId: undefined,
      debounceSearch: undefined,
      liffId: ''
    }
  },
  watch: {
    selectedDate() {
      this.query = ''
      this.pagination = { ...this.pagination, page: 1 }
    },
    pagination() {
      this.fetch()
    }
  },
  created() {
    this.debounceSearch = debounce(() => {
      this.pagination = { ...this.pagination, page: 1 }
    }, 500)
  },
  methods: {
    async fetch() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 1000)
    },
    exportData() {
      const rows = [
        [
          [
            'จาก',
            dayjs(this.selectedDate.start).startOf('day').format(DATETIME.DATETIME_FORMAT_DISPLAY),
            'ถึง',
            dayjs(this.selectedDate.end).endOf('day').format(DATETIME.DATETIME_FORMAT_DISPLAY)
          ].join(' ')
        ],
        ['ชื่อลิงก์', 'URL', 'วันที่สร้าง'],
        []
      ]
      const worksheet = XLSX.utils.aoa_to_sheet(rows)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Links')
      XLSX.writeFile(workbook, 'links.xlsx')
    },
    handleAdd() {
      this.editedItem = null
    },
    handleLiffIdAdd() {
      this.editedLiffId = null
    },
    handleFormSubmit(form, done) {
      console.log(form, done)
    },
    handleLiffIdFormSubmit(form, done) {
      console.log(form, done)
    },
    handleItemEdit(item) {
      this.editedItem = item
    },
    async handleItemDelete(item) {
      const { value } = await this.$swal.fire({
        title: this.$t('link_deletion_confirmation'),
        text: item.name,
        type: 'question',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel')
      })
      if (!value) return
      console.log('delete', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar {
  /deep/ {
    .v-toolbar__content {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/my-allianz/LinkManagement/index.vue